import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removePanelsFromRequest } from "../../redux/pvDesign";
import { reduxLocalStorage } from "../utility/storage";
import { pvDesignApi } from "../../services/pvDesignApi";
import { MdDelete } from "react-icons/md";
import { ImSpinner } from "react-icons/im";
import { FaBroom } from "react-icons/fa";
import { Button } from "react-bootstrap";

const PVDesignRemovePVsBox = () => {
  const dispatch = useDispatch();
  const { selectedRequestId, selectedPanelIds } = useSelector((s) => s.pvDesign);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const selectedCount = useMemo(() => Object.values(selectedPanelIds).filter(Boolean).length, [selectedPanelIds]);
  const projectId = reduxLocalStorage.getItem("project_id");

  if (!selectedRequestId) return null;

  const handleRemove = async () => {
    const panelIds = Object.entries(selectedPanelIds)
      .filter(([, v]) => v)
      .map(([k]) => k);
    try {
      setIsSubmitting(true);
      await pvDesignApi.removePanels({ projectId, requestId: selectedRequestId, panelIds });
      dispatch(removePanelsFromRequest({ requestId: selectedRequestId, panelIds }));
    } catch (e) {
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    selectedCount > 0 && (
    <div className="pv-selection-overlay pv-selection-overlay--center">
      <span >{selectedCount} Panels Selected</span>
      <Button onClick={handleRemove} disabled={isSubmitting || selectedCount === 0} variant="danger" className=""  >
        {isSubmitting ? <ImSpinner size={16} className="pv-spin"/> : <MdDelete size={16}/>}
        <span style={{marginLeft: 4}}>{isSubmitting ? "Removing..." : "Remove "}</span>
      </Button> 
      
      <Button variant="outline-secondary" onClick={() => dispatch(removePanelsFromRequest({ requestId: selectedRequestId, panelIds: [] }))} className="" disabled={selectedCount === 0}>
        <FaBroom size={16}/>
        <span style={{marginLeft: 4}}>Clear</span>
      </Button>
    </div>
      )
  );
};

export default PVDesignRemovePVsBox;


